import type { SxProps } from "@mui/joy/styles/types";
import DarkTypography from "../../common/DarkTypography";
import {
  statsBadgeDangerSx,
  statsBadgeMutedSx,
  statsBadgeSuccessSx,
  statsBadgeWarningSx,
} from "../../../styles/globalStyles";
import type { StatsMetricTone } from "../statsPeriodHelpers";

const BADGE_SX_BY_TONE: Record<Exclude<StatsMetricTone, "plain">, SxProps> = {
  success: statsBadgeSuccessSx,
  danger: statsBadgeDangerSx,
  warning: statsBadgeWarningSx,
  muted: statsBadgeMutedSx,
};

type StatsMetricValueProps = {
  tone: StatsMetricTone;
  value: string;
};

export default function StatsMetricValue({ tone, value }: StatsMetricValueProps) {
  if (tone === "plain") {
    return (
      <DarkTypography
        level="body-sm"
        colorVariant="title"
        component="span"
        sx={{ fontWeight: 600 }}
      >
        {value}
      </DarkTypography>
    );
  }
  return (
    <DarkTypography
      level="body-sm"
      component="span"
      sx={{ ...BADGE_SX_BY_TONE[tone], px: 1, display: "inline-block" }}
    >
      {value}
    </DarkTypography>
  );
}
